import { Button, IconButton, styled } from '@mui/material';
import ReactPlayer from 'react-player';

const Root = styled('section')({
  position: 'relative',
  backgroundColor: '#000',
});

const Controls = styled('div')({
  position: 'absolute',
  width: '90%',
  bottom: '20px',
  left: '20px',
});

const Video = styled(ReactPlayer)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const Stopwatch = styled('time')({
  fontSize: 24,
  color: 'rgba(255,255,255,0.7)',
});

const PlayButton = styled(IconButton)({
  position: 'absolute',
  top: 0,
  left: 0,
  backgroundColor: 'transparent',
  border: 'none',
  outline: 'none',
  width: '100%',
  height: '100%',
  color: 'rgba(255,255,255,0.5)',
});

const ToAnomalyButton = styled(Button)({
  border: '1px solid rgba(0, 0, 0, 0.12)',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    border: '1px solid rgba(0, 0, 0, 0.12)',
  },
  '&:not(:last-of-type):hover': {
    borderRightColor: 'rgba(0, 0, 0, 0.12) !important',
  },
});

export { Root, Controls, Video, Stopwatch, PlayButton, ToAnomalyButton };
